import * as e from "react";
import a from "../lib/IconBase.es.js";
import f from "../defs/FilePdf.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: f }));
o.displayName = "FilePdfIcon";
const c = o;
export {
  c as FilePdf,
  o as FilePdfIcon
};
